import { useEffect, useState } from "react";
import {
  DEFAULT_IMAGE_URL,
  handleImageError,
  markImageFailed,
  resolveImageUrl,
} from "../../helper/image";

/**
 * Shows DEFAULT.PNG until `src` has finished loading, then swaps in.
 */
const DeferredImage = ({ src, onError, ...props }) => {
  const resolvedSrc = resolveImageUrl(src);
  const [displaySrc, setDisplaySrc] = useState(DEFAULT_IMAGE_URL);

  useEffect(() => {
    if (!resolvedSrc || resolvedSrc === DEFAULT_IMAGE_URL) {
      setDisplaySrc(DEFAULT_IMAGE_URL);
      return undefined;
    }

    let cancelled = false;
    setDisplaySrc(DEFAULT_IMAGE_URL);

    const img = new Image();
    img.onload = () => {
      if (!cancelled) {
        setDisplaySrc(resolvedSrc);
      }
    };
    img.onerror = () => {
      markImageFailed(resolvedSrc);
      markImageFailed(img.src);
      if (!cancelled) {
        setDisplaySrc(DEFAULT_IMAGE_URL);
      }
    };
    img.src = resolvedSrc;
    if (img.complete && img.naturalWidth > 0 && !cancelled) {
      setDisplaySrc(resolvedSrc);
    }

    return () => {
      cancelled = true;
    };
  }, [resolvedSrc]);

  return (
    <img
      {...props}
      src={displaySrc}
      onError={onError || handleImageError}
    />
  );
};

export default DeferredImage;
